import { render, staticRenderFns } from "./MessageItem.vue?vue&type=template&id=095b0d43"
import script from "./MessageItem.vue?vue&type=script&lang=ts"
export * from "./MessageItem.vue?vue&type=script&lang=ts"
import style0 from "./MessageItem.vue?vue&type=style&index=0&id=095b0d43&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports